<p-overlay-badge [value]="notificationBadgeValue()" badgeSize="small" [badgeDisabled]="notificationBadgeValue() === 0">
	<p-button icon="pi pi-bell"
			  [rounded]="true"
			  (click)="panel.toggle($event)"
			  variant="outlined"></p-button>
</p-overlay-badge>

<p-popover #panel
		   [dismissable]="true"
		   styleClass="w-27rem p-0 overflow-auto"
		   [style]="{maxHeight: '60vh'}"
		   appendTo="body">
	<div class="flex flex-column">
		<!-- HEADER -->
		<div class="flex align-items-center justify-content-between p-3 surface-0 sticky top-0 z-1 -mt-3">
			<span class="font-bold uppercase">Notifiche</span>
			<p-select-button [options]="notificationTypes"
							 (onChange)="filterNotificationType($event)" />
			<p-button variant="outlined"
					  size="small"
					  rounded
					  icon="pi pi-check"
					  pTooltip="Segna tutte come lette"
					  (onClick)="setAllNotificationAsReaded()"
					  [disabled]="notificationBadgeValue() === 0"/>
		</div>

		<!-- NOTIFICATIONS -->
		<div class="px-2">
			@if (notifications().length > 0) {
				@for ( n of notifications(); track n.id ) {
					<p-overlay-badge badgeSize="small"
									 [badgeDisabled]="n.read"
									 class="p-1">
						<p-button severity="secondary"
								  styleClass="w-full p-3 border-round-xl"
								  [pTooltip]="n.read ? '' : 'Segna come letta'"
								  (onClick)="setNotificationReaded(n)">
							<div class="flex flex-column align-items-start gap-2 w-full">
								<div class="w-full flex justify-content-between align-items-center font-bold uppercase text-sm">
									<span class="flex gap-2 align-items-center">
										<i [class]="`${n.icon} text-xs`"></i>
										{{ n.title }}
									</span>
									<span>{{ n.created_at | date:'dd/MM/y HH:mm':'':'IT-it' }}</span>

									@if (n.ticket_code && n.subject) {
										<span>{{ n.ticket_code }} - {{n.subject}}</span>
									}
								</div>
								<div class="text-left" [innerHTML]="n.message"></div>

								@if (n.from_email !== '') {
									<small>da {{ n.from_email }}</small>
								}
							</div>
						</p-button>
					</p-overlay-badge>
				}
			} @else {
				<div class="surface-50 border-round-2xl w-full h-15rem flex justify-content-center align-items-center">
					<span class="font-bold uppercase">Nessuna notifica</span>
				</div>
			}
		</div>
	</div>
</p-popover>
